import { Action } from 'redux';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetDescription } from '../AppActionTypes';

export interface SetDescriptionAction extends Action {
  item: IContentInfo<'database'> | IContentInfo<'table'>;
}

export function setDescriptionAction(item: IContentInfo<'database'> | IContentInfo<'table'>): SetDescriptionAction {
  return {
    type: SetDescription,
    item
  };
}
